// @flow
import ModulesSwitcher from './modules-switcher';

export default ModulesSwitcher;
